export const formatCurrency = (
  value: number = 0,
  currency: string = "USD",
  display: "code" | "symbol" = "symbol"
) => {
  const formatted = value.toLocaleString("en-US", {
    style: "currency",
    currency,
    currencyDisplay: display, // "code" -> USD, "symbol" -> $
  });

  // Insert a space between the currency and the number
  return formatted.replace(/(\p{Sc}|[A-Z]{3})(\d)/u, "$1 $2");
};
